import ERRORS from '~/constants/errors';

import { Rule } from './types';

export const employeeCountRule: Rule = ({ businessDetails, isPropertyOwner }) => {
  if (
    isPropertyOwner ||
    !businessDetails ||
    businessDetails.employeeCount === undefined ||
    businessDetails.industry === undefined
  )
    return undefined;
  // Note: Special rule for plumbing:
  // https://www.ato.gov.au/Business/Industry-specific-guides/Plumbing-and-gas-fitting-industry/Plumbing-and-gas-fitting-industry---ATO-guidance/
  const maxEmployees =
    businessDetails.occupationCategory?.categoryCode === '0112'
      ? 1
      : (businessDetails.industry?.limits?.noOfEmployees ?? 0);
  if (businessDetails.employeeCount > maxEmployees) {
    return ERRORS.employeeCount;
  }
  return undefined;
};
